import { useUserAgentContext } from './context';

export function useIsBot(): boolean {
	const { bot } = useUserAgentContext();
	return bot;
}
